import { useState, useRef, Fragment, useContext, useEffect } from 'react';
import { history } from 'umi';
import Context from '@/utils/context';
import { Row, Col, Tabs } from 'antd';
import { Form, message, Typography } from 'iglooform';
import { useIntl } from 'react-intl';
import { BackButton } from '@/components/back-button/back-button';
import { HeaderTitle } from '@/components/header-title/header-title';
import SkeletonLoading from '@/components/skeleton-loading';
import {
  sendEmailOtp,
  sendPhoneOtp,
  getAgencyInfo,
  verifyEmailOtp,
  verifyPhoneOtp,
} from '../service';
import './index.less';
import _ from 'lodash';

const { TabPane } = Tabs;

const ForgetPasswordPage = () => {
  const form = Form.useForm();
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);

  const tabKey = useRef(sessionStorage.getItem('VERIFYTABKEY') || 'phone');

  const [countdown, setCountdown] = useState<number>(
    Number(localStorage.getItem('COUNTDOWN')) > 0
      ? Number(localStorage.getItem('COUNTDOWN'))
      : 0,
  );
  const [emailCountDown, setEmailountdown] = useState<number>(
    Number(localStorage.getItem('EMAILCOUNTDOWN')) > 0
      ? Number(localStorage.getItem('EMAILCOUNTDOWN'))
      : 0,
  );
  const [userInfo, setUserInfo] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleChange = (value: any) => {
    sessionStorage.setItem('VERIFYTABKEY', value);
    tabKey.current = value;
  };

  const getOtp = () => {
    if (tabKey.current === 'phone') {
      sendPhoneOtp({
        phone_area_code: '84',
        phone_number: userInfo?.phone_number,
        platform: 'Agency',
      }).then((res) => {
        if (res?.status === 'ok') {
          // 开启倒计时
          setCountdown(60);
          const timer = setInterval(() => {
            setCountdown((prevTime) => {
              if (prevTime - 1 === 0) {
                localStorage.removeItem('COUNTDOWN');
                localStorage.removeItem('FORGOTPAYMENTPATHNAME');
                window.clearInterval(timer);
              }
              localStorage.setItem(
                'FORGOTPAYMENTPATHNAME',
                '/me/forget-payment-password',
              );
              localStorage.setItem('COUNTDOWN', String(prevTime - 1));
              return prevTime - 1;
            });
          }, 1000);
        }
      });
    }
    if (tabKey.current === 'email') {
      sendEmailOtp({
        email: userInfo?.email,
        platform: 'Agency',
      }).then((res) => {
        if (res?.status === 'ok') {
          // 开启倒计时
          setEmailountdown(60);
          const timer = setInterval(() => {
            setEmailountdown((prevTime) => {
              if (prevTime - 1 === 0) {
                localStorage.removeItem('EMAILCOUNTDOWN');
                localStorage.removeItem('FORGOTPAYMENTPATHNAME');
                window.clearInterval(timer);
              }
              localStorage.setItem(
                'FORGOTPAYMENTPATHNAME',
                '/me/forget-payment-password',
              );
              localStorage.setItem('EMAILCOUNTDOWN', String(prevTime - 1));
              return prevTime - 1;
            });
          }, 1000);
        }
      });
    }
  };

  const resendCountdownText = (
    <Typography level="body1" style={{ color: '#BDBDBD' }}>
      {formatMessage(
        {
          id: 'Resend in {countdown}(s)',
          defaultMessage: 'Resend in {countdown}(s)',
        },
        {
          countdown: tabKey.current === 'phone' ? countdown : emailCountDown,
        },
      )}
    </Typography>
  );

  const getOtpThrottle = _.throttle(getOtp, 1000, {
    leading: true,
    trailing: false,
  });

  const resendBtn = (
    <a onClick={getOtpThrottle}>{formatMessage({ id: 'Send OTP' })}</a>
  );

  const handleGetAgencyInfo = _.throttle(
    async (): Promise<void> => {
      setLoading(true);
      getAgencyInfo()
        .then((res) => {
          if (res) {
            setUserInfo(res.userInfo);
            form.setFieldValue(
              ['phoneNumber', 'phoneNumber'],
              res.userInfo.phone_number,
            );
            form.setFieldValue(['email'], res.userInfo.email);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
    1000,
    { leading: true, trailing: false },
  );

  const handleCheckOTP = _.throttle(
    async (value: any): Promise<void> => {
      if (tabKey.current === 'phone') {
        verifyPhoneOtp({
          phone_area_code: '84',
          phone_number: userInfo?.phone_number,
          code: value.phoneOtp,
        }).then((res) => {
          if (res?.valid === true) {
            history.push(
              '/me/forget-payment-password/reset-payment-password?otp_code=' +
                value.phoneOtp +
                '&otp_type=phone',
            );
          } else if (res?.valid === false) {
            message.error(formatMessage({ id: 'Invalid OTP entered' }));
          }
        });
      }
      if (tabKey.current === 'email') {
        verifyEmailOtp({
          email: userInfo?.email,
          code: value.emailOtp,
        }).then((res) => {
          if (res?.valid) {
            history.push(
              '/me/forget-payment-password/reset-payment-password?otp_code=' +
                value.emailOtp +
                '&otp_type=email',
            );
          } else if (res?.valid === false) {
            message.error(formatMessage({ id: 'Invalid OTP entered' }));
          }
        });
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  useEffect(() => {
    handleGetAgencyInfo();
    if (emailCountDown > 0) {
      const emailTimer = setInterval(() => {
        setEmailountdown((prevTime) => {
          if (prevTime - 1 === 0) {
            localStorage.removeItem('EMAILCOUNTDOWN');
            window.clearInterval(emailTimer);
          }
          localStorage.setItem('EMAILCOUNTDOWN', String(prevTime - 1));
          return prevTime - 1;
        });
      }, 1000);
    }

    if (countdown > 0) {
      const timer = setInterval(() => {
        setCountdown((prevTime) => {
          if (prevTime - 1 === 0) {
            localStorage.removeItem('COUNTDOWN');
            window.clearInterval(timer);
          }
          localStorage.setItem('COUNTDOWN', String(prevTime - 1));
          return prevTime - 1;
        });
      }, 1000);
    }
  }, []);

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      {!loading ? (
        <Row style={isPc ? { marginTop: '40px' } : { marginTop: '24px' }}>
          <Col
            span={isPc ? 12 : 24}
            style={{ maxWidth: '538px', margin: '0 auto' }}
          >
            <HeaderTitle
              title={formatMessage({ id: 'Verify' })}
              subTitle={formatMessage({
                id: 'Please verify your identity first.',
              })}
            />

            <section
              className="verify-container"
              style={!isPc ? { marginTop: 24 } : {}}
            >
              <Tabs
                size="large"
                destroyInactiveTabPane={true}
                className="card-out-box"
                onChange={handleChange}
                defaultActiveKey={tabKey.current}
              >
                <TabPane
                  tab={
                    <Typography level="h2">
                      {formatMessage({ id: 'Phone' })}
                    </Typography>
                  }
                  key="phone"
                >
                  <div style={{ marginTop: '48px' }}>
                    <Form
                      form={form}
                      config={{
                        type: 'Login',
                        elements: [
                          {
                            type: 'PhoneNumber',
                            label: formatMessage({ id: 'Mobile Number' }),
                            name: 'phoneNumber',
                            fullRow: true,
                            required: true,
                            areaCode: '+84',
                            disabled: true,
                          },
                          {
                            type: 'Input',
                            label: formatMessage({ id: 'OTP Code' }),
                            name: 'phoneOtp',
                            fullRow: true,
                            required: true,
                            initialValue: '',
                            extraLabel: (
                              <Typography level="body1">
                                {countdown ? resendCountdownText : resendBtn}
                              </Typography>
                            ),
                          },
                        ],
                      }}
                      onSubmit={handleCheckOTP}
                      locales={{
                        submitText: formatMessage({
                          id: 'Next',
                        }),
                        validateMessages: {
                          required:
                            '${label} ' +
                            formatMessage({
                              id: 'is required',
                            }),
                        },
                      }}
                    />
                  </div>
                </TabPane>
                <TabPane
                  tab={
                    <Typography level="h2">
                      {formatMessage({ id: 'Email' })}
                    </Typography>
                  }
                  key="email"
                >
                  <div style={{ marginTop: '48px' }}>
                    <Form
                      form={form}
                      config={{
                        type: 'Login',
                        elements: [
                          {
                            type: 'Input',
                            label: formatMessage({ id: 'Email' }),
                            name: 'email',
                            fullRow: true,
                            required: true,
                            disabled: true,
                            rules: [
                              {
                                validator: (_: any, value: string) => {
                                  const regExp =
                                    /^(\s+|[a-zA-Z0-9._-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+([a-zA-Z]|\s+)$/;
                                  if (!!value && !regExp.test(value)) {
                                    return Promise.reject(
                                      new Error(
                                        formatMessage({
                                          id: 'Email format is not correct!',
                                        }),
                                      ),
                                    );
                                  } else {
                                    return Promise.resolve();
                                  }
                                },
                              },
                            ],
                          },
                          {
                            type: 'Input',
                            label: formatMessage({ id: 'OTP Code' }),
                            name: 'emailOtp',
                            fullRow: true,
                            required: true,
                            initialValue: '',
                            extraLabel: (
                              <Typography level="body1">
                                {emailCountDown
                                  ? resendCountdownText
                                  : resendBtn}
                              </Typography>
                            ),
                          },
                        ],
                      }}
                      onSubmit={handleCheckOTP}
                      locales={{
                        submitText: formatMessage({
                          id: 'Next',
                        }),
                        validateMessages: {
                          required:
                            '${label} ' +
                            formatMessage({
                              id: 'is required',
                            }),
                        },
                      }}
                    />
                  </div>
                </TabPane>
              </Tabs>
            </section>
          </Col>
        </Row>
      ) : (
        <div style={{ marginTop: '45px' }}>
          <SkeletonLoading />
        </div>
      )}
    </Fragment>
  );
};

export default ForgetPasswordPage;
